var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"admin-electric-chart"},[_c('div',{ref:"chartRef",staticClass:"chart-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }